"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _measureScrollbarWidth = _interopRequireDefault(require("./measureScrollbarWidth"));

var DisableScroll = (0, _styledComponents.createGlobalStyle)(["body{overflow:hidden;margin-right:", " !important;}"], function (_ref) {
  var reserveScrollBarGap = _ref.reserveScrollBarGap;
  return reserveScrollBarGap ? (0, _measureScrollbarWidth["default"])() + "px" : "initial";
});
var _default = DisableScroll;
exports["default"] = _default;